<template>
  <div class="media-com">
    <div class="media-box" v-for="(item, index) in mediaList" :key="index">
      <div class="media-img">
        <img class="img" :src="item.media_img" alt="" />
      </div>
      <p class="media-title">
        <a :href="item.media_link" target="_branch">{{
          $t(preList + item.title)
        }}</a>
      </p>
      <p class="media-date">
        「{{ $t(preList + item.name) }}」—
        {{ $t(preList + item.date) }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    mediaList: Array,
    year: String
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["headType"]),
    preList() {
      if (this.year === "2021") {
        if (this.headType === "2") {
          return "media_2022_Girl.";
        } else {
          return "media_2022.";
        }
      } else if (this.year === "2022") {
        if (this.headType === "2") {
          return "media_2023_Girl.";
        } else {
          return "media_2023.";
        }
      } else if(this.year === "2024"){
         if (this.headType === "2") {
          return "media_2024_Girl.";
        } else {
          return "media_2024.";
        }
      } 
      else {
        return "media.";
      }
      
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.media-com {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-left: 3%;
  .media-box {
    width: 25%;
    margin: 40px;
    .media-img {
      width: 100%;
      height: 220px;
      .img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
        object-fit: cover;
        object-position: center;
      }
    }
    .media-title {
      padding: 10px 0;
      a {
        text-decoration: none;
        color: #000;
      }
      a:hover {
        text-decoration: underline;
        color: #5aa2d3;
      }
    }
    .media-date {
      font-size: 15px;
      color: gray;
    }
  }
}
@media screen and (max-width: 768px) {
  .media-com {
    .media-box {
      width: 90%;
      margin-left: 7px;
    }
  }
}
</style>
